export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/sellerBannerIcon-28b1dffb55308781e09805d38ebab965.svg";